import { render } from "./NewProductCard.vue?vue&type=template&id=6dd3e403&scoped=true"
import script from "./NewProductCard.vue?vue&type=script&lang=js"
export * from "./NewProductCard.vue?vue&type=script&lang=js"

import "./NewProductCard.vue?vue&type=style&index=0&id=6dd3e403&scoped=true&lang=scss"

import exportComponent from "/Users/alex/lab_dev_test/info-global/info_front_new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dd3e403"]])

export default __exports__